import React from 'react';

const clauses = [
  {
    title: 'Artikel 1 — Partijen',
    text: 'Opdrachtnemer: [Naam], [Adres], ondernemingsnummer BE[0000.000.000], btw-nummer BE[0000.000.000]. Opdrachtgever: [Bedrijfsnaam], [Adres], ondernemingsnummer BE[0000.000.000]. Hierna gezamenlijk aangeduid als "de Partijen".',
  },
  {
    title: 'Artikel 2 — Vergoeding en Betalingsvoorwaarden',
    text: 'Opdrachtgever betaalt Opdrachtnemer een vergoeding van € [bedrag], exclusief BTW (21%). Facturen dienen te worden voldaan binnen 30 dagen na factuurdatum. Bij overschrijding van de betalingstermijn is van rechtswege en zonder ingebrekestelling een verwijlintrest verschuldigd conform de Belgische Wet van 2 augustus 2002 betreffende de bestrijding van betalingsachterstand.',
  },
  {
    title: 'Artikel 3 — Toepasselijk Recht',
    text: 'Op deze overeenkomst is uitsluitend Belgisch recht van toepassing. Alle geschillen die voortvloeien uit of verband houden met deze overeenkomst worden voorgelegd aan de bevoegde rechtbank te [Brussel / Antwerpen / Gent], tenzij partijen schriftelijk een andere wijze van geschillenbeslechting overeenkomen.',
  },
  {
    title: 'Artikel 4 — Zelfstandige Status',
    text: 'Opdrachtnemer voert de opdracht uit als zelfstandige in de zin van de Belgische wetgeving. Er bestaat geen arbeidsrelatie tussen Partijen. Opdrachtnemer is verantwoordelijk voor zijn eigen sociale bijdragen als zelfstandige en voor de naleving van alle fiscale verplichtingen als zelfstandige ondernemer.',
  },
];

const BelgiumClauses = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Voorbeeldclausules voor Belgische freelancers</h2>
    <p className="text-gray-600 mb-6">Realistische clausules die Pactorae genereert voor Belgische zelfstandigen:</p>
    <div className="space-y-4">
      {clauses?.map((clause, i) => (
        <div key={i} className="border border-gray-200 rounded-xl p-6 bg-white shadow-sm">
          <h3 className="font-bold text-[#2F4E6F] mb-3">{clause?.title}</h3>
          <p className="text-gray-700 leading-relaxed text-sm font-mono bg-gray-50 p-4 rounded-lg">{clause?.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default BelgiumClauses;
